export default __webpack_public_path__ + "static/media/IMG_5350.d86032fe.WEBP";